/* ============================================================================
   CircadianSync landing interactions (vanilla JS, no dependencies).
   Converted from design_handoff_shopify_landing/circadiansync-landing.html.
   Click/submit handlers use document-level delegation so they keep working
   when the Shopify theme editor re-renders a section; observers are rebuilt
   on shopify:section:load.
   ============================================================================ */
(function(){
  'use strict';

  /* ---- 1. System tabs ---- */
  document.addEventListener('click', function(e){
    var tab = e.target.closest('.sys-tab');
    if(!tab) return;
    var phase = tab.getAttribute('data-phase');
    document.querySelectorAll('.sys-tab').forEach(function(t){
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    document.querySelectorAll('.sys-panel').forEach(function(p){
      var on = p.getAttribute('data-phase') === phase;
      p.classList.toggle('is-active', on);
      if(on){ p.removeAttribute('hidden'); } else { p.setAttribute('hidden',''); }
    });
  });

  /* ---- 2. Science research drawer ---- */
  document.addEventListener('click', function(e){
    var toggle = e.target.closest('.sci-drawer-toggle');
    if(!toggle) return;
    var drawer = toggle.closest('.sci-drawer');
    var open = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- 3. FAQ accordion (single-open) ---- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('.faq-q');
    if(!q) return;
    var item = q.closest('.faq-item');
    var isOpen = item.classList.contains('is-open');
    document.querySelectorAll('.faq-item').forEach(function(other){
      other.classList.remove('is-open');
      var oq = other.querySelector('.faq-q');
      if(oq) oq.setAttribute('aria-expanded','false');
    });
    if(!isOpen){
      item.classList.add('is-open');
      q.setAttribute('aria-expanded','true');
    }
  });

  /* ---- 4. Reserve buttons: preselect tier from offer ladder ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.js-reserve');
    if(!btn) return;
    var tier = btn.getAttribute('data-tier');
    if(!tier) return;
    var map = { full:'Full System Subscription', pack:'System Pack', single:'Individual Pouch' };
    var val = map[tier];
    var radio = document.querySelector('.wl-tier input[value="'+val+'"]');
    if(radio){ radio.checked = true; }
  });

  /* ---- 5+6. Observers: sticky reserve CTA + reveal on scroll ---- */
  var stickyObservers = [];
  var revealObserver = null;
  function setupObservers(){
    stickyObservers.forEach(function(o){ o.disconnect(); });
    stickyObservers = [];
    if(revealObserver){ revealObserver.disconnect(); revealObserver = null; }
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.cs-reveal').forEach(function(el){ el.classList.add('is-in'); });
      return;
    }

    var sticky = document.getElementById('cs-sticky');
    var hero = document.getElementById('cs-hero');
    var waitlist = document.getElementById('cs-waitlist');
    if(sticky && hero && waitlist){
      var heroVisible = true, waitlistVisible = false;
      var syncSticky = function(){
        var show = !heroVisible && !waitlistVisible;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      var ho = new IntersectionObserver(function(e){ heroVisible = e[0].isIntersecting; syncSticky(); },{threshold:0.15});
      ho.observe(hero);
      var wo = new IntersectionObserver(function(e){ waitlistVisible = e[0].isIntersecting; syncSticky(); },{threshold:0.2});
      wo.observe(waitlist);
      stickyObservers.push(ho, wo);
    }

    revealObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
      });
    },{threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.cs-reveal').forEach(function(el){ revealObserver.observe(el); });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', setupObservers);
  } else {
    setupObservers();
  }
  document.addEventListener('shopify:section:load', setupObservers);
  document.addEventListener('shopify:section:unload', setupObservers);

  /* ---- 7. Waitlist form → Klaviyo client-side subscribe ---- */
  /*  Keys are injected by sections/cs-waitlist.liquid via window.CS_KLAVIYO
      (section settings "Klaviyo public API key" / "Klaviyo list ID").
      While either is missing or 'XXXXXX', the form confirms optimistically
      without a network call (demo mode). */
  function klaviyoConfig(){
    var cfg = window.CS_KLAVIYO || {};
    return {
      publicKey: (cfg.publicKey || 'XXXXXX').trim(),
      listId: (cfg.listId || 'XXXXXX').trim()
    };
  }

  function subscribeToKlaviyo(payload){
    /* Klaviyo Client API: Create Client Subscription (current, recommended).
       Safe for browser use - authenticates with the PUBLIC key only.
       Docs: https://developers.klaviyo.com/en/reference/create_client_subscription
       Success = HTTP 202 with an empty body. */
    var cfg = klaviyoConfig();
    var attributes = { email: payload.email };
    if(payload.first_name) attributes.first_name = payload.first_name;
    /* Klaviyo expects custom properties nested inside profile attributes */
    if(payload.tier) attributes.properties = { FoundingTier: payload.tier };
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'CircadianSync Founding Landing',
          profile: {
            data: {
              type: 'profile',
              attributes: attributes
            }
          }
        },

        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function(res){
      if(!res.ok) throw new Error('Klaviyo subscribe failed: ' + res.status);
      return res;
    });
  }

  document.addEventListener('submit', function(e){
    var form = e.target.closest('#wl-form');
    if(!form) return;
    e.preventDefault();

    var success = document.getElementById('wl-success');
    var errEl = document.getElementById('wl-error');
    var submitBtn = document.getElementById('wl-submit');
    var emailEl = document.getElementById('wl-email');
    if(!emailEl || !submitBtn) return;

    if(errEl) errEl.style.display = 'none';
    var email = emailEl.value.trim();
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if(!valid){
      if(errEl) errEl.style.display = 'block';
      emailEl.focus();
      return;
    }
    var nameEl = document.getElementById('wl-name');
    var checkedTier = document.querySelector('.wl-tier input:checked');
    var payload = {
      email: email,
      first_name: (nameEl && nameEl.value || '').trim(),
      tier: (checkedTier && checkedTier.value) || ''
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Reserving…';

    var showSuccess = function(){
      form.classList.add('is-hidden');
      if(success) success.classList.add('is-on');
    };
    var cfg = klaviyoConfig();
    var configured = cfg.publicKey !== 'XXXXXX' && cfg.publicKey !== '' && cfg.listId !== 'XXXXXX' && cfg.listId !== '';

    if(configured){
      /* Even on a network/CORS hiccup, confirm to the user; the lead intent
         is captured client-side and real wiring is verified at launch. */
      subscribeToKlaviyo(payload).then(showSuccess).catch(showSuccess);
    } else {
      setTimeout(showSuccess, 450);
    }
  });
})();
